import factory from '../octicon.js';

// This is an auto-generated ES2015 icon from the modularize script. Please do not modify this file.
var bookmark = factory('bookmark', 10, 16, {"fill-rule":"evenodd","d":"M9 0H1C.27 0 0 .27 0 1v15l5-3.09L10 16V1c0-.73-.27-1-1-1zm-.78 4.25L6.36 5.61l.72 2.16c.06.22-.02.28-.2.17L5 6.6 3.12 7.94c-.19.11-.25.05-.2-.17l.72-2.16-1.86-1.36c-.17-.16-.14-.23.09-.23l2.3-.03.7-2.16h.25l.7 2.16 2.3.03c.23 0 .27.08.09.23h.01z"}, ["tab","star"]);

export default bookmark;
